module.exports = __webpack_public_path__ + "static/media/reception-3.61a894a8.jpg";